<div class="app-container w-100 m-0-auto p-relative border-box">
    <div class="flex p-fixed z-index-10 pd-0-3 a-center tx-center top-0">
        <button mat-icon-button type="button" [matMenuTriggerFor]="menu">
            <mat-icon>menu_open</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="goToOrdersList()">
                Список заявок
            </button>
            @if (hasCashMachine) {
                <button mat-menu-item (click)="addCashMachine()" >
                    Касса
                </button>
            }
            <button mat-menu-item (click)="logout()">
                Выход
            </button>
        </mat-menu>
    </div>

    <mat-toolbar class="flex-row j-center p-relative">
        @if (progress() !== 100 && progress() !== 0) {
            <div class="progress">
                <div class="flex progress-container">
                    <mat-icon class="arrow-icon">arrow_downward</mat-icon>
                    {{ progress() }}%
                </div>
            </div>
        }
        @if (hasCashMachine) {
            <span class="serial-number">{{authService.user().data.paymentDevice?.serialNumber || ''}}</span>
        }@else {
            <span class="executor">Исполнитель</span>
        }
        <div class="date flex p-absolute z-index-10 a-center tx-center pd-0-3">
            <span>
                {{dateService.currentDate() | date : 'dd MMM'}}
            </span>

            <mat-form-field class="datepicker-container">
                <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <button class="date-bnt" (click)="openDatePicker()">
                <mat-icon>calendar_today</mat-icon>
            </button>
            <div class="network-indicator">
                @if (offlineService.offline()) {
                    <mat-icon class="orange-icon">wifi_off</mat-icon>
                }@else {
                    <mat-icon class="green-icon">wifi</mat-icon>
                }
            </div>
        </div>
    </mat-toolbar>

    <div class="flex-1 h-100 scroll-auto pd-1 content">
        <router-outlet></router-outlet>
    </div>
</div>
